import { Alert, Box, Button } from '@mui/material';
import PageContainer from '../layout/PageContainer';
import { useCallback, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useNotifications from '../../hooks/useNotifications/useNotifications';
import api from '../../api/axiosInstance';

export default function EmailValidated() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const notifications = useNotifications();

  const emailValidated = !!searchParams.get('validated');

  const [creatingPasskey, setCreatingPasskey] = useState(false);
  const [passkeyCreated, setPasskeyCreated] = useState(false);

  const createPasskey = useCallback(async () => {
    setPasskeyCreated(false);

    setCreatingPasskey(true);

    try {
      const { data: createPasskeyResult } = await api.post(
        '/create-passkey',
        {
          userId: searchParams.get('userId')
        });

      if (createPasskeyResult.createPasskeySuccessful) {
        if (createPasskeyResult.passkeyCreationOptions) {

          const options = PublicKeyCredential.parseCreationOptionsFromJSON(
            JSON.parse(createPasskeyResult.passkeyCreationOptions));

          const credential = await navigator.credentials.create({ publicKey: options });

          const { data: passkeyAttestationResult } = await api.post(
            '/perform-passkey-attestation',
            {
              userId: searchParams.get('userId'),
              credential: JSON.stringify(credential)
            });

          if (passkeyAttestationResult.passkeyAttestationSuccessful) {
            setPasskeyCreated(true);
          } else if (passkeyAttestationResult.passkeyAttestationUnsuccessfulReason) {
            notifications.show(
              passkeyAttestationResult.passkeyAttestationUnsuccessfulReason,
              {
                severity: 'error'
              });
          }
        }
      } else if (createPasskeyResult.createPasskeyUnsuccessfulReason) {
        notifications.show(
          createPasskeyResult.createPasskeyUnsuccessfulReason,
          {
            severity: 'error'
          });
      }
    }
    catch (error: any) {
      notifications.show(
        error.message, {
        severity: 'error',
      });
    }

    setCreatingPasskey(false);

  }, [notifications, searchParams]);

  return <PageContainer
    title="Validate Email"
  >
    <Box>
      {emailValidated && !passkeyCreated ?
        <Alert severity="success">
          Email validated. Click the "Create Passkey" button to create a passkey.
        </Alert> :
        <></>
      }
      {!emailValidated && !passkeyCreated ?
        <Alert severity="error">
          Email could not be validated. Please try again.
        </Alert> :
        <></>
      }
      {passkeyCreated ?
        <Alert severity="success">
          Passkey created. Click the "Login" button to login.
        </Alert> :
        <></>
      }
    </Box>
    <Box sx={{ mt: 2 }}>
      {emailValidated && !passkeyCreated ?
        <Button
          variant="contained"
          loading={creatingPasskey}
          onClick={createPasskey}>
          Create Passkey
        </Button> :
        <></>
      }
      {passkeyCreated ?
        <Button
          variant="contained"
          onClick={() => navigate('/login')}>
          Login
        </Button> :
        <></>
      }
    </Box>
  </PageContainer>
}
